import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import axios from 'axios';
import Multiselect from 'multiselect-react-dropdown';
import { Loader } from '../../../../../../pip/apps/components';

const FundsByApplication = () => {
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [incentives, setIncentives] = useState(0);
  const [applicationsCount, setApplicationsCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    status: [],
    state: '',
    equipmentType: ''
  });
  const [statusSelect, setStatusSelect] = useState([]);
  const [statesList, setStatesList] = useState(
    window.wlFipAdmin.overviewStates
  );
  const [selectedStates, setSelectedStates] = useState([]);
  const statuses = [
    { status: 'In Progress', id: 'In Progress' },
    { status: 'Submitted', id: 'Submitted' },
    { status: 'Incomplete', id: 'Incomplete' },
    { status: 'Approved', id: 'Approved' },
    { status: 'Complete', id: 'Complete' }
  ];
  const equipmentTypes = {
    irrigationEngine: 'Irrigation Engine',
    buildingHeat: 'Building Heat',
    waterHeating: 'Water Heating',
    powerGenerator: 'Power Generator',
    flameWeeding: 'Flame Weeding'
  };

  // get application data
  useEffect(() => {
    setLoading(true);
    const formData = new FormData();
    formData.append('action', 'wl_fip_admin_get_applications');

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(({ data: { success, data } }) => {
        if (success) {
          setApplications(data);
          setFilteredApplications(data);
          setApplicationsCount(data.length);

          let totalIncentive = 0;
          data.forEach(
            ({ incentiveAmount }) =>
              (totalIncentive += parseInt(incentiveAmount))
          );
          setIncentives(totalIncentive);
        } else {
          setApplications({});
        }

        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  // Sets numbers based on filters
  useEffect(() => {
    setApplicationsCount(filteredApplications.length);
    let totalIncentive = 0;
    let states = {};
    let statesOptions = [];

    filteredApplications.forEach(({ incentiveAmount, state }) => {
      states[state] = state;
      return (totalIncentive += parseInt(incentiveAmount));
    });

    Object.values(states).forEach(
      (state) => state && statesOptions.push({ state })
    );

    setIncentives(totalIncentive);
    setStatesList(statesOptions);
  }, [filteredApplications]);

  // handles the filtering
  useEffect(() => {
    let filtered = [...applications];

    Array.from(['status', 'state', 'equipmentType']).forEach((param) => {
      if (filter[param] && filter[param] !== '' && filter[param].length) {
        filtered = filtered.filter((application) =>
          param === 'status'
            ? filter[param].includes(application[param])
            : filter[param] === application[param]
        );
      }
    });

    setFilteredApplications(filtered);
  }, [filter]);

  // sets the filter parameters
  const handleChange = ({ target: { value, name } }) => {
    setFilter({
      ...filter,
      [name]: value
    });
  };

  const handleSelectStatus = (selectedList, selectedItem) => {
    setStatusSelect(selectedList);
    setFilter({
      ...filter,
      status: [...filter.status, selectedItem.status]
    });
  };

  const handleRemoveStatus = (selectedList, removedItem) => {
    setStatusSelect(selectedList);
    setFilter({
      ...filter,
      status: filter.status.filter((status) => status !== removedItem.status)
    });
  };

  const handleSelectState = (selectedList, selectedItem) => {
    setSelectedStates(selectedList);
    setFilter({
      ...filter,
      state: selectedItem.state
    });
  };

  const handleRemoveState = (selectedList, removedItem) => {
    setSelectedStates(selectedList);
    setFilter({
      ...filter,
      state: ''
    });
  };

  const multiselectStyles = {
    searchBox: {
      borderColor: '#9ca4a7',
      borderRadius: 0,
      boxShadow: '0px 3px 6px rgb(56 72 78 / 20%)',
      padding: '9.7px'
    },
    inputField: {
      color: '#38484e',
      fontFamily: '"neo-sans", sans-serif'
    },
    chips: {
      backgroundColor: '#008485'
    }
  };

  return (
    <div className="grid grid__col-xs-12 u--margin-top-30-md-max">
      <div className="grid__col-xs-12">
        <h3 className="u--margin-bottom-10">FUNDS BY APPLICATION</h3>
      </div>
      <div className="grid__col_xs_12 u--display-flex u--flex-direction-column u--flex-direction-row-xl-min u--justify-content-space-between u--width-100 u--padding-bottom-30 u--padding-left-20">
        <div className="fip-multiselect form__field">
          <label className="form__label u--margin-top-10">
            Filter by Status:
          </label>
          <Multiselect
            options={statuses}
            placeholder="-- Status --"
            selectedValues={statusSelect}
            onSelect={handleSelectStatus}
            onRemove={handleRemoveStatus}
            displayValue="status"
            className="form__select form__select-lg"
            closeOnSelect={true}
            style={multiselectStyles}
          />
        </div>
        <div className="fip-multiselect form__field">
          <label className="form__label u--margin-top-10">
            Filter By State:
          </label>
          <Multiselect
            options={statesList}
            placeholder="-- State --"
            selectedValues={selectedStates}
            onSelect={handleSelectState}
            onRemove={handleRemoveState}
            displayValue="state"
            className="form__select form__select-lg"
            closeOnSelect={true}
            selectionLimit={1}
            style={multiselectStyles}
          />
        </div>
        <div className="form__field">
          <label className="form__label u--margin-top-10">
            Filter By Equipment Type:
          </label>
          <div className="form__select form__select--lg">
            <select
              className="form__input form__input--lg"
              onChange={(event) => handleChange(event)}
              name="equipmentType"
              value={filter.equipmentType}
            >
              <option value="">-- Please select equipment type --</option>
              {Object.entries(equipmentTypes).map((type) => (
                <option key={type[0]} value={type[0]}>
                  {type[1]}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="grid__col-xs-12 grid__col-md-6 u--text-align-center-sm-max">
            <h4 className={`h2 u--margin-0`}>
              <CountUp end={applicationsCount} duration={1.5} />
            </h4>
            <p>Applications</p>
          </div>
          <div className="grid__col-xs-12 grid__col-md-6 u--text-align-center-sm-max">
            <h4 className={`h2 u--margin-0`}>
              <CountUp
                prefix={'$'}
                end={incentives}
                separator={','}
                duration={1.5}
              />
            </h4>
            <p>Total Incentives</p>
          </div>
        </>
      )}
    </div>
  );
};

export default FundsByApplication;
